var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrevious(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.24 7.21957V16.7896C20.24 18.7496 18.11 19.9796 16.41 18.9996L12.26 16.6096L8.10996 14.2096C6.40996 13.2296 6.40996 10.7796 8.10996 9.79957L12.26 7.39957L16.41 5.00957C18.11 4.02957 20.24 5.24957 20.24 7.21957Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.76001 18.9303C3.35001 18.9303 3.01001 18.5903 3.01001 18.1803V5.82031C3.01001 5.41031 3.35001 5.07031 3.76001 5.07031C4.17001 5.07031 4.51001 5.41031 4.51001 5.82031V18.1803C4.51001 18.5903 4.17001 18.9303 3.76001 18.9303Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevious);
export default __webpack_public_path__ + "static/media/previous.65824ab5251c01485e4999a1bce4e561.svg";
export { ForwardRef as ReactComponent };